<template>
    <div>
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-input size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">新增配置</el-button>
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading">
            <el-table-column prop="description" label="名称" min-width="100"></el-table-column>
            <el-table-column prop="key" label="键值" min-width="100"></el-table-column>
            <el-table-column prop="type" label="类型" min-width="100"></el-table-column>
            <el-table-column prop="value" label="设置情况" min-width="100">
                <template slot-scope="scope">
                    <div v-if="scope.row.type == 'bool'">
                        <el-tag type="success" v-if="scope.row.value">开启</el-tag>
                        <el-tag type="info" v-else>关闭</el-tag>
                    </div>
                    <div v-else>{{scope.row.value}}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="编辑" placement="top-start">
                          <i class="NavIcon el-icon-edit"@click="ToggleDig(scope.row)"></i>                    
                    </el-tooltip>
                    <el-tooltip effect="dark" content="删除" placement="top-start">                        <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>                    </el-tooltip>              
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol" hide-on-single-page>
        </el-pagination>
        <el-dialog title="修改配置" :visible.sync="NewData.NewBlon" width="25%" class="BorderRadius">
            <div class="DigItem">
                <div class="DigItemTit">名称：</div>
                <el-input class="Wid" size="medium" placeholder="请输入名称" v-model="NewData.description"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">键值：</div>
                <el-input class="Wid" size="medium" placeholder="请输入键值" v-model="NewData.key" :disabled="Type!='Add'"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">类型：</div>
                <el-select class="Wid" size="medium"  v-model="NewData.type" placeholder="请选择类型">
                      <el-option label="int" value="int"></el-option>
                      <el-option label="string" value="string"></el-option>
                      <el-option label="Boolean" value="bool"></el-option>
                </el-select>
            </div>
            <div class="DigItem" v-if="NewData.type!=''&&NewData.type!='bool'">
                <div class="DigItemTit">内容：</div>
                <el-input class="Wid" size="medium" placeholder="请输入内容" v-model="NewData.value"></el-input>
            </div>
            <div class="DigItem" v-if="NewData.type!=''&&NewData.type=='bool'">
                <div class="DigItemTit">状态：</div>
                <el-switch class="Wid" v-model="NewData.value" active-color="#13ce66" inactive-color="#ddd"/>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(NewData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="Suc">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AdminIndex",
        data() {
            return {
                loading:false,
                SearchVal:"",
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                Type:'Add',
                NewData:{
                    id:'',
                    NewBlon:false,
                    description:"",
                    value:"",
                    type:"int",
                    key:"",
                },
            };
        },
        mounted() {
            this.GetData();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/config/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = Object.values(res.data.config).flat();
                        // this.Totol = res.data.total;
                    }
                })
            },
            ToggleDig(row){
                this.$Tools.ResetData(this.NewData)
                if(row!='Add'){
                    this.Type='Edi';
                    this.NewData.id = row.id;
                    this.NewData.description = row.description;
                    this.NewData.type = row.type;
                    this.NewData.value = row.value;
                    this.NewData.key = row.key;
                }else{
                    this.Type='Add';
                }
                this.NewData.NewBlon = true;
            },
            Suc(){
                if(this.Type=='Add'){
                    this.SucNew();
                }else{
                    this.SucEdit();
                }
            },
            SucEdit(){
                var Query = [{
                    "key":this.NewData.key,
                    "description": this.NewData.description,
                    "value": this.NewData.value,
                }]
                this.$post('/admin/config/update',{
                    "configs": Query,
                }).then(res=>{
                    if(res){
                        this.$message.success("修改成功");
                        this.GetData();
                        this.$Tools.ResetData(this.NewData)
                    }
                })
            },
            SucNew(row) {
                this.$post('/admin/config/save',{
                    "config_key":this.NewData.key,
                    "config_value":this.NewData.value,
                    "config_type": "int",
                    "config_group": "system",
                    "description": this.NewData.description,
                }).then(res=>{
                    if(res){
                        this.$message.success("添加成功");
                        this.ReSetPage();
                        this.$Tools.ResetData(this.NewData)
                    }
                })
            },
            Delete(id) {
                this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/admin/config/delete',{
                        id:id
                    }).then(res=>{
                        if(res){
                            this.$message.success("删除成功!");
                            this.GetData();
                        }
                    })
                })
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    
</style>
